export default "__VITE_ASSET__DJyA5K_0__"